/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Rail_NpInputs */

const en_ui_rail_np = /** @type {(inputs: Ui_Rail_NpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NP`)
};

const de_ui_rail_np = /** @type {(inputs: Ui_Rail_NpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NP`)
};

/**
* | output |
* | --- |
* | "NP" |
*
* @param {Ui_Rail_NpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_rail_np = /** @type {((inputs?: Ui_Rail_NpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Rail_NpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_rail_np(inputs)
	return de_ui_rail_np(inputs)
});